export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-branches',
}

export const TRANSLATION_KEYS_RETAIL = {
  fieldLabel: 'partnerbasicinfo-branches-retail',
}

export const TRANSLATION_KEYS_DISTRIBUTOR = {
  fieldLabel: 'partnerbasicinfo-branches-distributor',
}
